import { action } from "typesafe-actions";
import { ThunkAction } from "redux-thunk";
import { IStoreState } from "../../initialStoreState";
import { AnyAction } from "redux";
import { api } from "../../../api/api";
import { getFilenameFromContentDisposition } from "../../../helpers";
import {
  saveLoaderCompleted,
  saveLoaderProgress,
  showMessage,
} from "../../messages/messagesActions";
import {
  IAccountingCheque,
  initialAccountingChequeState,
} from "./Cheque.types";
import { IDataTableV2DateState } from "../../../components/TableV2/preDefinedPlugins/DataTableV2Date/DataTableV2Date.types";
import { IDatatableV2AdvancedSearchFilter } from "../../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { getFileExtensionFromUrl } from "../../../helpers";

export const FETCH_ACCOUNTING_CHEQUE_LIST_PROGRESS =
  "FETCH_ACCOUNTING_CHEQUE_LIST_PROGRESS";
export const FETCH_ACCOUNTING_CHEQUE_LIST_SUCCESS =
  "FETCH_ACCOUNTING_CHEQUE_LIST_SUCCESS";
export const FETCH_ACCOUNTING_CHEQUE_LIST_FAILURE =
  "FETCH_ACCOUNTING_CHEQUE_LIST_FAILURE";

export const fetchAccountingChequeListProgress = () =>
  action(FETCH_ACCOUNTING_CHEQUE_LIST_PROGRESS);

export const fetchAccountingChequeListSuccess = (data: IAccountingCheque[]) =>
  action(FETCH_ACCOUNTING_CHEQUE_LIST_SUCCESS, { data });

export const fetchAccountingChequeListFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_CHEQUE_LIST_FAILURE, { errorMessage });

export const fetchAccountingChequeListAsync =
  (
    pageNumber: number,
    rowsInPerPage: number,
    limit: number,
    status: string,
    date: IDataTableV2DateState["dates"],
    searchValue: IDatatableV2AdvancedSearchFilter
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingChequeListProgress());

      let finalUrl = `/accounting/get-account-cheque?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${date.fromDate}&to_date=${date.toDate}`;
      if (searchValue.length > 0) {
        finalUrl = `/accounting/get-account-cheque?pageNo=${pageNumber}&pageLimit=${limit}&itemPerPage=${rowsInPerPage}&from_date=${
          date.fromDate
        }&to_date=${date.toDate}&advanceFilter=${JSON.stringify(searchValue)}`;
      }
      if (status !== "-1") {
        finalUrl += "&status=" + status;
      }
      const res = await api.get(finalUrl);
      const data: IAccountingCheque[] = res.data.data;
      dispatch(fetchAccountingChequeListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAccountingChequeListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

interface IChequeValues {
  from_date: string;
  to_date: string;
 status: string;
  bank_account: string;
}

export const fetchAccountingChequeListForExportAsync =
  (
    values: IChequeValues,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());

      let finalUrl = `/accounting/get-account-cheque-report-pdf?`;

      if(values.status){
        finalUrl = finalUrl + "status="+values.status;
      }

      if (values.from_date) {
        const filterObj = {
          column: ["cheque_date"],
          operator: "GREATER_THAN_EQUAL",
          value: values.from_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (values.to_date) {
        const filterObj = {
          column: ["cheque_date"],
          operator: "LESSER_THAN_EQUAL",
          value: values.to_date,
          logicalOperator: "AND",
        };

        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      if (values.bank_account) {
        const filterObj = {
          column: ["bank_account"],
          operator: "EQUAL",
          value: values.bank_account,
          logicalOperator: "AND",
        };
        const encodedFilter = encodeURIComponent(
          JSON.stringify(filterObj, null, 2)
        );
        finalUrl += `&advanceFilter=${encodedFilter}`;
      }
      // if (values.cheque_cleared) {
      //   const filterObj = {
      //     column: ["cheque_cleared"],
      //     operator: "EQUAL",
      //     value: values.cheque_cleared,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}&`;
      // }
      // if (values.cheque_voided) {
      //   const filterObj = {
      //     column: ["cheque_voided"],
      //     operator: "EQUAL",
      //     value: values.cheque_voided,
      //     logicalOperator: "AND",
      //   };

      //   const encodedFilter = encodeURIComponent(
      //     JSON.stringify(filterObj, null, 2)
      //   );
      //   finalUrl += `&advanceFilter=${encodedFilter}&`;
      // }

      const res = await api.get(finalUrl, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data], {
        type: "application/" + getFileExtensionFromUrl("Cheque.pdf"),
      });
      // const blob = new Blob([res.data], { type: "application/octet-stream" });
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to trigger the download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Cheque.pdf"); // Set the desired file name and extension
      document.body.appendChild(link);
      link.click();

      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const FETCH_ACCOUNTING_CHEQUE_PROGRESS =
  "FETCH_ACCOUNTING_CHEQUE_PROGRESS";
export const FETCH_ACCOUNTING_CHEQUE_SUCCESS =
  "FETCH_ACCOUNTING_CHEQUE_SUCCESS";
export const FETCH_ACCOUNTING_CHEQUE_FAILURE =
  "FETCH_ACCOUNTING_CHEQUE_FAILURE";

export const fetchAccountingChequeProgress = () =>
  action(FETCH_ACCOUNTING_CHEQUE_PROGRESS);

export const fetchAccountingChequeSuccess = (data: IAccountingCheque) =>
  action(FETCH_ACCOUNTING_CHEQUE_SUCCESS, { data });

export const fetchAccountingChequeFailed = (errorMessage: string) =>
  action(FETCH_ACCOUNTING_CHEQUE_FAILURE, { errorMessage });

export const fetchAccountingChequeAsync =
  (chequeId: number): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingChequeProgress());

      const res = await api.get(
        `/accounting/get-account-cheque?cheque_id=${chequeId}`
      );
      const data: IAccountingCheque[] = res.data.data;
      if (data.length > 0) {
        dispatch(fetchAccountingChequeSuccess(data[0]));
      } else {
        dispatch(
          fetchAccountingChequeSuccess(initialAccountingChequeState["data"])
        );
      }
    } catch (err: any) {
      dispatch(fetchAccountingChequeFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };

export const addAccountingChequeAysnc =
  (
    data: IAccountingCheque,
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/edit-account-cheque", {
        ...data,
      });
      const message = "Cheque saved successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const fetchAllChequeListAsync = (): ThunkAction<
  void,
  IStoreState,
  {},
  AnyAction
> => {
  return async (dispatch, getState) => {
    try {
      dispatch(fetchAccountingChequeListProgress());
      const finalUrl = `/accounting/get-account-cheque?status=ACTIVE`;

      const res = await api.get(finalUrl);
      const data: IAccountingCheque[] = res.data.data;
      dispatch(fetchAccountingChequeListSuccess(data));
    } catch (err: any) {
      dispatch(fetchAccountingChequeListFailed("Something went to be wrong!"));
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    }
  };
};

export const downloadCheque =
  (
    cheque_id: string,
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/accounting/get-account-cheque-pdf?cheque_id=${cheque_id}`,
        {
          responseType: "arraybuffer",
        }
      );

      const pdfBuffer = res.data;

      const pdfBlob = new Blob([pdfBuffer], { type: "application/pdf" });

      const pdfUrl = URL.createObjectURL(pdfBlob);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = getFilenameFromContentDisposition(res);
      link.click();

      URL.revokeObjectURL(pdfUrl);
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const previewCheque =
  (
    cheque_id: string,
    onCallback: () => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      const res = await api.get(
        `/accounting/get-account-cheque-pdf?cheque_id=${cheque_id}&is_cheque_preview=true`
      );

      for (const key in res.data.data) {
        const newTab = window.open("", "_blank");
        if (newTab) {
          newTab.document.write(res.data.data[key]);
          newTab.document.close();
        }
      }
      onCallback();
    } catch (err: any) {
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const updateReconciledStatusofCheque =
  (
    data: {
      cheque_id: string;
      reconciled: string;
      reconciled_date?: string | null;
    },
    onCallback: (isSuccess: boolean) => void
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      dispatch(saveLoaderProgress());
      await api.post("/accounting/edit-account-create-bill", {
        cheque_id: data.cheque_id,
        reconciled: data.reconciled,
        reconciled_date: data.reconciled_date,
      });
      const message = "Bill reconciled successfully.";
      dispatch(
        showMessage({
          type: "success",
          message: message,
          displayAs: "snackbar",
        })
      );
      onCallback(true);
    } catch (err: any) {
      onCallback(false);
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        })
      );
    } finally {
      dispatch(saveLoaderCompleted());
    }
  };

export const CLEAR_ACCOUNTING_CHEQUE = "CLEAR_ACCOUNTING_CHEQUE";
export const clearAccountingCheque = () => action(CLEAR_ACCOUNTING_CHEQUE);
